﻿import TKBasketButton, { BasketActionTypes } from '@tk/components/tk.basket.button';
import KWPrice from '@/components/kw.price';
import KWStock from '@/components/kw.stock';
import KWBasketAction from '@/utilities/kw.basket.action';
import { BasketAction } from '@tk/utilities/tk.basket.action';

export default class KWBasketButton extends TKBasketButton {
    articleWrapper?: HTMLElement;
    basketAction: KWBasketAction;
    stockElement: KWStock | null | undefined;
    syncStock: boolean;
    checkQuantityAttribute: string;
    dimVariantAttribute: string;

    constructor() {
        super();

        this.basketAction = new KWBasketAction(this);
        this.articleWrapper = this.closest('[data-article-wrapper]') || undefined;
        this.stockElement = this.articleWrapper?.querySelector('.tk-stock');
        this.checkQuantityAttribute = 'data-tk-stock-check-qty';
        this.dimVariantAttribute = 'data-tk-dimension-variant';
        this.syncStock = !!this.stockElement && this.stockElement.getAttribute(this.checkQuantityAttribute) !== '';
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.registerInputListener();

        if (this.action === BasketActionTypes.ADD) this.setDefaultQuantity();
    }

    closeDialog(data: BasketData) {
        this.button!.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        let closeDialog = true;
        closeDialog = this.closest('[data-article-wrapper]').getAttribute('data-dialog-close');
        if (!closeDialog) {
            dialog.close();
        }
    }

    registerInputListener() {
        if (!this.counter) return;
        const onInput = this.syncPriceQuantity.bind(this);
        this.pushListener({
            event: 'input',
            element: this.counter,
            action: onInput,
        });
    }

    increase() {
        if (!this.counter || !this.increaser) return;
        const { step, max, value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
        this.syncPriceQuantity();
    }

    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step, min, value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
        this.syncPriceQuantity();
    }

    change(event: KeyboardEvent) {
        KWBasketAction.quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.button?.click();
            this.syncPriceQuantity();
        }, 500);
    }

    syncPriceQuantity() {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            if (!this.counter) return;
            const priceElement = this.articleWrapper?.querySelector<KWPrice>('tk-price');
            priceElement?.setAttribute('data-quantity', this.counter.value);
            this.syncStock && this.stockElement?.setAttribute(this.checkQuantityAttribute, this.counter.value);
        }, 500);
    }

    updateDimensions(event: Event): void {
        super.updateDimensions(event);
        const selectedVariant = event.target as HTMLInputElement;
        if (!this.syncStock || !this.stockElement) return;
        this.stockElement.setAttribute(this.checkQuantityAttribute, this.counter?.value || '1');
        this.stockElement.setAttribute(this.dimVariantAttribute, selectedVariant.value);
    }

    setDefaultQuantity(): void {
        const selectedVariant = this.getAttribute('data-tk-variant');

        console.log(this.action);

        if (!selectedVariant) throw new Error('KWBasketButton: Button has no variant attribute');

        const priceElement = this.articleWrapper?.querySelector<KWPrice>('tk-price');
        priceElement?.setAttribute('data-tk-dimension-variant', selectedVariant);
    }
}
